"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.install = exports.default = void 0;

var _canPublishCxEvent = _interopRequireDefault(require("./canPublishCxEvent"));

/* eslint-disable camelcase*/

/**
 * Publish a gtag event/item
 */
var gtag = function gtag() {
  // Can't use arrow func + destructuring as Google expects
  // arguments objects in dataLayer (not an array of arguments).
  if ((0, _canPublishCxEvent.default)()) {
    window.cxdataLayer.push(arguments);
  }
};
/**
 * Install and setup the GA analytics system
 * @param trackingId
 */


var install = function install(trackingId) {
  var scriptId = "cx-gtag";
  if (document.getElementById(scriptId)) return;
  var _document = document,
      head = _document.head;
  var script = document.createElement("script");
  script.id = scriptId;
  script.type = "text/javascript";
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=".concat(trackingId, "&l=cxdataLayer");
  head.insertBefore(script, head.firstChild);
  window.cxdataLayer = window.cxdataLayer || [];
  gtag("js", new Date());
  gtag("config", trackingId, {
    anonymize_ip: true
  });
  gtag("set", "allow_google_signals", false);
};

exports.install = install;
var _default = gtag;
exports.default = _default;